/* ADA interim shim — TEMPORARY. Remove once Shogun checklist (audit §4) is complete. */
(function () {
  function applyShim() {
    // §J: Give every unlabelled Google Maps iframe a title
    document.querySelectorAll('iframe[src*="google.com/maps"]:not([title])').forEach(function (f) {
      f.setAttribute('title', 'Map to Blue Ridge Distilling Co');
    });

    // §I: Hide decorative Vimeo background iframe from AT and keyboard
    document.querySelectorAll('iframe[src*="background=1"]').forEach(function (f) {
      f.setAttribute('aria-hidden', 'true');
      f.setAttribute('tabindex', '-1');
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyShim);
  } else {
    applyShim();
  }
})();
